import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import { memo } from "react";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import FormNumberField from "components/FormNumberField";

/* eslint-disable react/prop-types */

function Fields5({ formData }) {
  const { formField5, values, errors, touched } = formData;
  const {
    taxpayers,
    taxCode,
    taxAgentName,
    taxAgentCode,

    supportData,
  } = formField5;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormNumberField
            name={taxpayers.name}
            label={taxpayers.label}
            value={values.taxpayers}
            error={errors.taxpayers && touched.taxpayers}
            success={values.taxpayers?.toString().length > 0 && !errors.taxpayers}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormNumberField
            name={taxCode.name}
            label={taxCode.label}
            value={values.taxCode}
            error={errors.taxCode && touched.taxCode}
            success={values.taxCode?.toString().length > 0 && !errors.taxCode}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormNumberField
            name={taxAgentName.name}
            label={taxAgentName.label}
            value={values.taxAgentName}
            error={errors.taxAgentName && touched.taxAgentName}
            success={values.taxAgentName?.toString().length > 0 && !errors.taxAgentName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormNumberField
            name={taxAgentCode.name}
            label={taxAgentCode.label}
            value={values.taxAgentCode}
            error={errors.taxAgentCode && touched.taxAgentCode}
            success={values.taxAgentCode?.toString().length > 0 && !errors.taxAgentCode}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField
            name={supportData.name}
            label={supportData.label}
            value={values.supportData}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(Fields5);
